export const mixins = {
	data () {
		let staticClass = this.$vnode.data.staticClass
		let numStr = staticClass.match(/ceiba-comp-\d+/)
		numStr = numStr[0].replace(/ceiba-comp-/, '')
		let actId = this.$actConfig.actId
		let name = this.$options.name
		return {
			moduleid: numStr,
			pvKey: `h5_${actId}_${numStr}_${name}`
		}
	},
}



// WEBPACK FOOTER //
// ./src/components/actModules/src/h5mixins.js